import NewsletterApi from '../api/rest/directus-cms/newsletter';
import { newsletterData } from '../stores/stores';
export async function fetchNewsletter(lang) {
    await NewsletterApi.getInstance()
        .getNewsletter(lang)
        .then(response => {
        newsletterData.set(response);
    })
        .catch(error => {
        console.log('Error fetching Newsletter', error);
    });
}
